export enum EKwikUICheckboxSize {
  M = "m",
  L = "l"
}
export const VKwikUICheckboxSize = [
  EKwikUICheckboxSize.M,
  EKwikUICheckboxSize.L
] as const;
export type TKwikUICheckboxSize = (typeof VKwikUICheckboxSize)[number];

export enum EKwikUICheckboxContentAlign {
  LEFT = "left",
  RIGHT = "right"
}
export const VKwikUICheckboxContentAlign = [
  EKwikUICheckboxContentAlign.RIGHT,
  EKwikUICheckboxContentAlign.LEFT
] as const;
export type TKwikUICheckboxContentAlign =
  (typeof VKwikUICheckboxContentAlign)[number];

export enum EKwikUICheckboxVarient {
  BASIC = "basic",
  BLOCK = "block",
  LABELED = "labeled"
}
export const VKwikUICheckboxVarient = [
  EKwikUICheckboxVarient.BASIC,
  EKwikUICheckboxVarient.BLOCK,
  EKwikUICheckboxVarient.LABELED
] as const;
export type TKwikUICheckboxVarient = (typeof VKwikUICheckboxVarient)[number];
